import type { Dispatch, AnyAction } from 'redux';

import * as FindForJobAPI from 'ab-api/web/billingCode/findForJob';
import * as FindForJobTrackingAPI from 'ab-api/web/billingCode/findForJobTracking';
import * as FindGroupsAPI from 'ab-api/web/billingCode/findGroups';

import type { BillingCodeVM } from 'ab-viewModels/billingCode.viewModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

export function findForJobId(jobId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<BillingCodeVM[]>(API.V1.BILLING_CODE.FIND_BY_JOB_ID(jobId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findForJobTracking(jobId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			const result = await http.get<FindForJobTrackingAPI.W_BillingCode_FindForJobTracking_VM>(FindForJobTrackingAPI.URL(jobId));
			return result.items;
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findAllForProjectByJobId(jobId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			const result = await http.get<FindForJobAPI.W_BillingCode_FindForJob_VM>(FindForJobAPI.URL(jobId));
			return result.items;
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function getGroups(jobId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			const result = await http.get<FindGroupsAPI.W_BillingCode_FindGroups_VM>(FindGroupsAPI.URL(jobId));
			return result.groups;
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
